import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import CreationUploader from './creation-uploader.vue';
import featureTagConfig from '../configuration-scheme/feature-tag-config.vue';
import { removeFileExtension } from '@/common/file';

export default {
  components: {
    CreationUploader: CreationUploader,
    featureTagConfig: featureTagConfig
  },

  props: {
    deliver: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    copyTag: {
      type: String,
      default: ''
    },
    copyScene: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      formConfig: {},
      formItemList: {
        name: {
          label: '创意名称',
          prop: 'name',
          rules: [{
            required: true,
            message: '请输入创意名称',
            trigger: 'blur'
          }],
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入创意名称'
          }
        },

        tag_ids: {
          label: '创意标签',
          prop: 'tag_ids',
          rules: [{
            required: true,
            message: '请选择创意标签',
            trigger: 'change'
          }],
          params: {
            params: { type: 2 }
          }
        },

        path: {
          label: '创意附件',
          prop: 'path',
          rules: [{
            required: true,
            message: '请上传创意附件',
            trigger: 'change'
          }]
        }
      }
    };
  },


  computed: {
    // 如果有 file_name 和 url 加工 fileList
    fileList: function fileList() {
      if (this.deliver.file_name && this.deliver.url) {
        return [{
          name: this.deliver.file_name,
          url: this.deliver.url
        }];
      }
      return [];
    },
    isVideoFile: function isVideoFile() {
      // console.log(this.deliver.path.indexOf('mp4'))
      return this.deliver.path.indexOf('mp4') > -1 || this.deliver.path.indexOf('mov') > -1;
    },
    isGameByAppCatId: function isGameByAppCatId() {
      var _this = this;

      var list = [{ id: 8, name: '动作' }, { id: 9, name: '角色扮演' }, { id: 10, name: '休闲' }, { id: 11, name: '策略' }, { id: 12, name: '棋牌' }, { id: 13, name: '音乐' }, { id: 14, name: '益智' }, { id: 15, name: '体育' }, { id: 16, name: 'AVG' }];
      return list.some(function (item) {
        return Number(_this.schemeValue.app_cat_ids) === item.id;
      });
    },
    featureTag: function featureTag() {
      var list = [];
      this.schemeValue.featureTagData.map(function (item, index) {
        if (item.sub_tags && item.sub_tags.length > 0) {
          list.push({
            label: item.name,
            prop: 'tag' + item.id,
            rules: [{
              required: item.is_required === 1 || false,
              message: '\u8BF7\u9009\u62E9' + item.name,
              trigger: 'change'
            }],
            params: {
              options: item.sub_tags,
              params: { type: 2 }
            }
          });
        }
      });
      return list;
    }
  },

  methods: {
    onUploadSuccess: function onUploadSuccess(res, file) {
      var path = _.get(res, 'data.file_path'); // 用作提交表单
      var url = _.get(res, 'data.url'); // 用作预览
      // 去做文件后缀
      var fileName = removeFileExtension(_.get(res, 'data.origin_name'));

      // 上传成功后，更新交付列表
      if (res.code === 0 && path && fileName && url) {
        this.updateDeliver({
          path: path,
          file_name: fileName,
          // 如果创意名称没值，使用文件名字作为创意名字
          name: this.deliver.name || fileName,
          url: url
        });
      } else {
        this.$message.error(res.msg || '上传失败，请重新尝试');
        this.emptyFileInfo();
      }
    },
    onFileChange: function onFileChange(file, fileList) {
      // 限制只有一个文件
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onFileRemove: function onFileRemove(file, fileList) {
      this.emptyFileInfo();
    },
    updateDeliver: function updateDeliver(deliver) {
      this.$emit('update-deliver', _extends({}, deliver));
    },
    updateSceneNum: function updateSceneNum(val) {
      this.updateDeliver({
        scene_num: val
      });
    },
    updateFeatureTag: function updateFeatureTag(tag) {
      this.updateDeliver({
        material_tag_ids: tag
      });
    },
    handleCopyTag: function handleCopyTag(deliver) {
      this.$emit('copy-deliverTag', _extends({}, deliver));
    },


    // handlePasteTag(deliver) {
    //   if (this.copyTag) {
    //     deliver.tag_ids = this.copyTag
    //   }
    //   this.$emit('update-deliver', { ...deliver })
    // },

    emptyFileInfo: function emptyFileInfo() {
      this.updateDeliver({ path: '', file_name: '', url: '', name: '' });
    },
    validate: function validate() {
      if (this.isVideoFile && this.isGameByAppCatId) {
        return this.$refs['deliver-form'].validate() && this.$refs['featureTagForm'].validate();
      }
      return this.$refs['deliver-form'].validate();
    }
  }
};